import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionModalComponent } from './subscription-modal.component';
import { NgZorroAntdModule } from "../../../modules/nz-zorro-antd.module";
import { TranslateModule } from "@ngx-translate/core";
import {FormsModule,ReactiveFormsModule} from "@angular/forms";
import {NgZorroIconModule} from "../../../modules/nz-icon-antd.module";

@NgModule({
	declarations: [
		SubscriptionModalComponent
	],
	imports: [
		CommonModule,
		NgZorroIconModule,
		NgZorroAntdModule,
		ReactiveFormsModule,
		FormsModule,
		TranslateModule
	]
})
export class SubscriptionModalModule { }
